import React, { useEffect, useState } from "react";
import { Button, Form, Breadcrumb, Row } from "react-bootstrap";
import useReactRouter from "use-react-router";
import * as _ from "lodash";
import {
  faUserCog,
  faComments
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  COLOR_APP,
  DEFAULT_MS_CLAIM_BALANCE,
  DEFAULT_REPLY_MESSAGE,
  DEFAULT_REPLY_POST_MESSAGE,
  DEFAULT_SUMMARY_MESSAGE,
} from "../../constants";
import { useToasts } from "react-toast-notifications";
import { GET_SETTINGS } from "../../graphql/setting/query";
import { useLazyQuery, useMutation } from "@apollo/client";
import insertTextAtCursor from "insert-text-at-cursor";
import { CREATE_SETTING, UPDATE_SETTING } from "../../graphql/setting/mutation";
import useWindowDimensions from "../../helpers/useWindowDimensions";
import styled from "styled-components";
import BasicModal from "../../components/BasicModal";

// Constants
const MSG_CLAIM_BALANCE_CHARACTER_LIMIT = 400;

//Use For SmartPhone
const types = ["ອໍເດີ້ເຂົ້າ", "ຄໍາແນະນໍາການຕັ້ງຄ່າ"];
const Tab = styled.button`
  font-size: 16px;
  cursor: pointer;
  opacity: 1;
  background: white;
  color: #252a31;
  border: 0;
  outline: 0;
  ${({ active }) =>
    active &&
    `
    border-bottom: 2px solid #422F90;
    border-width:100%;
    color: #422F90;
    opacity: 1;
  `}
`;

// Styled Components for Settings
const SettingsCard = styled.div`
  padding: 20px;
  border: 1px solid #ced4da;
  border-radius: 5px;
  background: #fff;
  margin: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const SettingsHeader = styled.h5`
  color: #1b1b1b;
  font-weight: bold;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ButtonContainer = styled.div`
  margin-top: 20px;
`;

const SaveButton = styled(Button)`
  background: ${COLOR_APP} !important;
  color: #fff !important;
  width: 100%;
  padding: 10px;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: ${COLOR_APP}dd !important;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const GuideSection = styled.div`
  padding: 15px;
  border: 1px solid #ced4da;
  border-radius: 5px;
  background: #f8f9fa;
  margin: 10px 0;
  
  @media (max-width: 768px) {
    padding: 10px;
    margin: 5px 0;
  }
`;

const GuideHeader = styled.h6`
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  color: #1b1b1b;
  margin-bottom: 15px;
  
  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 10px;
  }
`;

const GuideItem = styled.p`
  margin: 0;
  margin-top: 8px;
  font-family: "Times New Roman";
  font-size: 13px;
  color: rgb(0, 0, 0);
  line-height: 1.4;
  
  @media (max-width: 768px) {
    font-size: 12px;
    margin-top: 6px;
  }
`;

const VariableTag = styled.span`
  color: #1b1b1b;
  background: #eee;
  padding: 2px 8px 4px 8px;
  border-radius: 15px;
  font-weight: bold;
  font-size: 11px;
  display: inline-block;
  margin: 2px;
  
  @media (max-width: 768px) {
    font-size: 10px;
    padding: 1px 6px 2px 6px;
  }
`;

const ExampleSection = styled.div`
  padding: 15px;
  border: 1px solid #ced4da;
  border-radius: 5px;
  background: #fff;
  margin: 10px 0;
  border-left: 4px solid ${COLOR_APP};
  
  @media (max-width: 768px) {
    padding: 10px;
    margin: 5px 0;
  }
`;

function SettingsFacebook() {
  const { width, height } = useWindowDimensions();
  const { addToast } = useToasts();
  const { history } = useReactRouter();
  const [showLimitTextModal, setShowLimitTextModal] = useState(false);
  const [showLimitTxtClaimBalanceModal, setShowLimitTxtClaimBalanceModal] = useState(false);
  const [shopSettings, setShopSettings] = useState([]);
  const [facebookMessage, setFacebookMessage] = useState(DEFAULT_REPLY_MESSAGE);
  const [facebookSummaryMessage, setFacebookSummaryMessage] = useState(
    DEFAULT_SUMMARY_MESSAGE
  );
  const [facebookPostMessage, setFacebookPostMessage] = useState(
    DEFAULT_REPLY_POST_MESSAGE
  );
  const [fbClaimBalanceMsg, setFbClaimBalanceMsg] = useState(
    DEFAULT_MS_CLAIM_BALANCE
  );
  const [isContinueText, setIsContinueText] = useState(false);
  const [tabChoise, setTabChoice] = useState("ອໍເດີ້ເຂົ້າ");
  const textContinue = `ຄວາມຍາວຂອງຂໍ້ຄວາມທີ່ຈະສົ່ງຫາລູກຄ້າມີຄວາມ (${facebookMessage.length}) ຖ້າກາຍນີ້ອາດຈະບໍ່ສາມາດສົ່ງຂໍ້ຄວາມແຈ້ງເຕືອນໄປຫາລູກຄ້າທີ່ມາ CF ໃນໄລຟຂອງທ່ານ. ທ່ານຕ້ອງການຈະຕື່ມຂໍ້ຄວາມຖ້າບໍ?`;
  const textLimited = `ຄວາມຍາວຂອງຂໍ້ຄວາມທີ່ຈະສົ່ງຫາລູກຄ້າມີຄວາມ (${facebookMessage.length}) ທ່ານບໍ່ສາມາດເພີ່ມຂໍ້ຄວາມໄດ້ຫລາຍກວ່ານີ້.`;
  const [getSettings, { data: shopSettingData }] = useLazyQuery(GET_SETTINGS, {
    fetchPolicy: "cache-and-network",
  });
  const [createSetting, { loading: loadingCreateSetting }] = useMutation(CREATE_SETTING);
  const [updateSetting, { loading: loadingUpdateSetting }] = useMutation(UPDATE_SETTING);
  const [messageType, setMessageType] = useState("web_url");

  useEffect(() => {
    initSetting();
  }, []);

  useEffect(() => {
    // console.log("facebookMessage: ", facebookMessage)
  }, [facebookMessage])

  const initSetting = async () => {
    let SHOP_ID = await localStorage.getItem("SHOP");
    await getSettings({
      variables: {
        where: {
          shop: SHOP_ID,
        },
        orderBy: "createdAt_ASC"
      },
    });
  };

  useEffect(() => {
    if (shopSettingData && shopSettingData?.settings?.data?.length > 0) {
      setShopSettings(shopSettingData?.settings?.data[0]);
      setFacebookMessage(
        shopSettingData?.settings?.data[0]?.facebook
          ? shopSettingData?.settings?.data[0]?.facebook
          : facebookMessage
      );
      setFacebookSummaryMessage(
        shopSettingData?.settings?.data[0]?.facebookSummary
          ? shopSettingData?.settings?.data[0]?.facebookSummary
          : facebookSummaryMessage
      );
      setFacebookPostMessage(
        shopSettingData?.settings?.data[0]?.facebookPost
          ? shopSettingData?.settings?.data[0]?.facebookPost
          : facebookPostMessage
      );
    }
    setMessageType(shopSettingData?.settings?.data[0]?.msgType ?? "web_url");
    setFbClaimBalanceMsg(shopSettingData?.settings?.data[0]?.fbClaimBalanceMsg ?? DEFAULT_MS_CLAIM_BALANCE);
  }, [shopSettingData]);

  const _saveSetting = async () => {
    const SHOP_ID = await localStorage.getItem("SHOP");
    if (shopSettings.length <= 0) {
      await createSetting({
        variables: {
          data: {
            facebook: facebookMessage,
            facebookSummary: facebookSummaryMessage,
            facebookPost: facebookPostMessage,
            fbClaimBalanceMsg: fbClaimBalanceMsg,
            msgType: messageType,
            shop: SHOP_ID,
          },
        },
      });
      addToast("ຕັ້ງຄ່າຂໍ້ຄວາມສໍາເລັດ", {
        appearance: "success",
        autoDismiss: true,
      });
    } else {
      await updateSetting({
        variables: {
          where: {
            id: shopSettings.id,
          },
          data: {
            facebook: facebookMessage,
            facebookSummary: facebookSummaryMessage,
            facebookPost: facebookPostMessage,
            fbClaimBalanceMsg: fbClaimBalanceMsg,
            msgType: messageType,
          },
        },
      });
      addToast("ຕັ້ງຄ່າຂໍ້ຄວາມສໍາເລັດ", {
        appearance: "success",
        autoDismiss: true,
      });
    }
  };

  // Optimized onChange handler for claim balance message
  const handleClaimBalanceMessageChange = (e) => {
    const value = e?.target?.value || '';
    
    if (value.length >= MSG_CLAIM_BALANCE_CHARACTER_LIMIT) {
      setShowLimitTxtClaimBalanceModal(true);
      return;
    }
    
    setFbClaimBalanceMsg(value);
  };

  const textLiveMessageBox = React.createRef();
  const eventHandlerLiveMessage = function (input) {
    insertTextAtCursor(textLiveMessageBox.current, "{{" + input + "}}");
  };
  const textLiveSummaryMessageBox = React.createRef();
  const eventHandlerLiveSummaryMessage = function (input) {
    insertTextAtCursor(textLiveSummaryMessageBox.current, "{{" + input + "}}");
  };
  const textPostMessageBox = React.createRef();
  // const eventHandlerPostMessage = function (input) {
  //   insertTextAtCursor(textPostMessageBox.current, "{{" + input + "}}");
  // };
  const textPostSummaryMessageBox = React.createRef();
  const eventHandlerPostSummaryMessage = function (input) {
    insertTextAtCursor(textPostSummaryMessageBox.current, "{{" + input + "}}");
  };

  // Use For Phone
  const [active, setActive] = useState(types[0]);

  return (
    <div style={{ backgroundColor: "#f9f9f9", width: width }}>
      <BasicModal
        show={showLimitTextModal || showLimitTxtClaimBalanceModal}
        onHide={() => {
          setIsContinueText(false);
          setShowLimitTextModal(false);
          setShowLimitTxtClaimBalanceModal(false);
        }}
        okay={() => {
          setShowLimitTextModal(false);
          setShowLimitTxtClaimBalanceModal(false);
          setIsContinueText(true);
        }}
        title={facebookMessage.length >= 600 ? textLimited : textContinue}
        leftButtonName="ຍົກເລີກ"
        rightButtonName="ຕົກລົງ"
        Illustration={"images/Illustration.png"} />
      <div>
        {width > 700 ? (
          <div>
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => history.replace("/settings")}>
                ຕັ້ງຄ່າ
              </Breadcrumb.Item>
              <Breadcrumb.Item active>ຕອບກັບເຟສບຸກ</Breadcrumb.Item>
            </Breadcrumb>
            <div
              style={{
                padding: 20,
                paddingBottom: 0,
                border: "1px solid #ced4da",
                borderRadius: 5,
                background: "#fff",
                margin: 10,
              }}
            >
              <h5 style={{ color: "#1b1b1b", fontWeight: "bold" }}>
                {" "}
                <FontAwesomeIcon icon={faComments} /> ຂໍ້ຄວາມຕອບກັບເຟສບຸກໃນໄລຟ
                ເມື່ອລູກຄ້າ CF ຖືກ
              </h5>
              <div className="row">
                <div className="col-4" style={{ padding: 20 }}>
                  <Row>
                    <LiveMessage
                      rows={20}
                      placeholder="ລາຍລະອຽດຂໍ້ຄວາມທີ່ຈະຕອບກັບໃນເຟສບຸກ..."
                      contents={facebookMessage}
                      ref={textLiveMessageBox}
                      onChange={async (e) => {
                        // console.log("e?.target?.value.length: ", e?.target?.value.length)
                        if (e?.target?.value.length >= 600) {
                          setShowLimitTextModal(true);
                          if (e?.target?.value.length >= 700) return;
                          if (isContinueText) setFacebookMessage(e?.target?.value);
                          return;
                        }
                        setFacebookMessage(e?.target?.value);
                      }}
                    />
                  </Row>
                  <div style={{ marginTop: 24 }}>
                    <Button
                      style={{
                        background: COLOR_APP,
                        color: "#ffff",
                        width: "100%",
                      }}
                      disabled={loadingCreateSetting || loadingUpdateSetting}
                      onClick={_saveSetting}
                    >
                      {loadingCreateSetting || loadingUpdateSetting ? 'ກຳລັງບັນທຶກ....' : 'ບັນທຶກ'}
                    </Button>
                  </div>
                </div>
                <div className="col-8" style={{ padding: 20 }}>
                  <div className="row" style={{ margin: 0 }}>
                    <div className="col-6">
                      <p
                        style={{ margin: 0, fontSize: 20, fontWeight: "bold" }}
                      >
                        ຄໍາແນະນໍາການຕັ້ງຄ່າ (ຕອບກັບຊີເອຟ)
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.1{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}cfName{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ຊື່ຂອງຜູ້ CF ສິນຄ້າ&nbsp;
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.2{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}productName{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ຊື່ຂອງ ສິນຄ້າ&nbsp;
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.3{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}cfMessage{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ລະຫັດຊີເອຟສິນຄ້າ
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.4{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}price{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ລາຄາສິນຄ້າ
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.5{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}amountCf{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ຈຳນວນທີ່ CF
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.6{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}totalPrice{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ລວມເປັນເງິນ
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.7{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}currency{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ສະກຸນເງິນ
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.8{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}orderCount{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ຈໍານວນອໍເດີ້ທັງຫມົດ
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.9{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}summaryPrice{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ລາຄາລວມທັງຫມົດທຸກອໍເດີ້ກີບ
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.10{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}summaryPriceBaht{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ລາຄາລວມທັງຫມົດທຸກອໍເດີ້ເປັນບາດ
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.11{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}summaryPriceUsd{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ລາຄາລວມທັງຫມົດທຸກອໍເດີ້ເປັນໂດລາ
                        </span>
                      </p>
                    </div>
                    <div
                      className="col-6"
                      style={{ background: "#eee", borderRadius: 5 }}
                    >
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          &nbsp;=========ຕົວຢ່າງການຕັ້ງຄ່າ=======
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ສະບາຍດີ {"{"}
                          {"{"}cfName{"}"}
                          {"}"}, ຍິນດີລູກຄ້າທີ່ໄດ້ Cf ຖືກສິນຄ້ານີ້ແລ້ວເດີ
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ລະຫັດ: {"{"}
                          {"{"}cfMessage{"}"}
                          {"}"}
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ຊື່ສິນຄ້າ: {"{"}
                          {"{"}productName{"}"}
                          {"}"}
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ລາຄາ: {"{"}
                          {"{"}price{"}"}
                          {"}"}
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ຈຳນວນ: {"{"}
                          {"{"}amountCf{"}"}
                          {"}"}
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ລວມເປັນເງິນ: {"{"}
                          {"{"}totalPrice{"}"}
                          {"}"}
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ວັນທີ່: {"{"}
                          {"{"}datetime{"}"}
                          {"}"}
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          -----------------------
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ລູກຄ້າໄດ້ຄອມເມັ້ນ Cf ລະຫັດ ["{"{"}
                          {"{"}cfMessage{"}"}
                          {"}"}"]
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ຖ້າຈົບໄລຟ ແລ້ວລະບົບຈະແຈ້ງຍອດໃຫ້ລູກຄ້າເດີ້
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <br />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* END LIVE */}
            <div
              style={{
                padding: 20,
                paddingBottom: 0,
                border: "1px solid #ced4da",
                borderRadius: 5,
                background: "#fff",
                margin: 10,
              }}
            >
              <h5 style={{ color: "#1b1b1b", fontWeight: "bold" }}>
                {" "}
                <FontAwesomeIcon icon={faComments} /> ຂໍ້ຄວາມຕອບກັບເຟສບຸກໃນໂພສ
                ເມື່ອລູກຄ້າ CF ຖືກ
              </h5>
              <div className="row">
                <div className="col-4" style={{ padding: 20 }}>
                  <Row>
                    <LiveMessage
                      rows={20}
                      placeholder="ລາຍລະອຽດຂໍ້ຄວາມທີ່ຈະຕອບກັບໃນເຟສບຸກ..."
                      contents={facebookPostMessage}
                      ref={textPostMessageBox}
                      // onChange={(e) => setFacebookPostMessage(e?.target?.value)}
                      onChange={async (e) => {
                        // console.log("e?.target?.value.length: ", e?.target?.value.length)
                        if (e?.target?.value.length >= 600) {
                          setShowLimitTextModal(true);
                          if (e?.target?.value.length >= 700) return;
                          if (isContinueText) setFacebookPostMessage(e?.target?.value);
                          return;
                        }
                        setFacebookPostMessage(e?.target?.value);
                      }}
                    />
                  </Row>
                  <div style={{ marginTop: 24 }}>
                    <Button
                      style={{
                        background: COLOR_APP,
                        color: "#ffff",
                        width: "100%",
                      }}
                      disabled={loadingCreateSetting || loadingUpdateSetting}
                      onClick={_saveSetting}
                    >
                      {loadingCreateSetting || loadingUpdateSetting ? 'ກຳລັງບັນທຶກ....' : 'ບັນທຶກ'}
                    </Button>
                  </div>
                </div>
                <div className="col-8" style={{ padding: 20 }}>
                  <div className="row" style={{ margin: 0 }}>
                    <div className="col-6">
                      <p
                        style={{ margin: 0, fontSize: 20, fontWeight: "bold" }}
                      >
                        ຄໍາແນະນໍາການຕັ້ງຄ່າ (ຕອບກັບຊີເອຟ)
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.1{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}cfName{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ຊື່ຂອງຜູ້ CF ສິນຄ້າ&nbsp;
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.2{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}productName{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ຊື່ຂອງ ສິນຄ້າ&nbsp;
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.3{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}cfMessage{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ລະຫັດຊີເອຟສິນຄ້າ
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.4{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}price{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ລາຄາສິນຄ້າ
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.5{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}amountCf{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ຈຳນວນທີ່ CF
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.6{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}totalPrice{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ລວມເປັນເງິນ
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.7{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}datetime{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ວັນທີ CF
                        </span>
                      </p>

                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.8{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}summaryPrice{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ລາຄາລວມທັງຫມົດທຸກອໍເດີ້ກີບ
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.9{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}summaryPriceBaht{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ລາຄາລວມທັງຫມົດທຸກອໍເດີ້ເປັນບາດ
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.10{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}summaryPriceUsd{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ລາຄາລວມທັງຫມົດທຸກອໍເດີ້ເປັນໂດລາ
                        </span>
                      </p>
                    </div>
                    <div
                      className="col-6"
                      style={{ background: "#eee", borderRadius: 5 }}
                    >
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          &nbsp;=========ຕົວຢ່າງການຕັ້ງຄ່າ=======
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ສະບາຍດີ {"{"}
                          {"{"}cfName{"}"}
                          {"}"}, ຍິນດີລູກຄ້າທີ່ໄດ້ Cf ຖືກສິນຄ້ານີ້ແລ້ວເດີ
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ລະຫັດ: {"{"}
                          {"{"}cfMessage{"}"}
                          {"}"}
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ຊື່ສິນຄ້າ: {"{"}
                          {"{"}productName{"}"}
                          {"}"}
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ລາຄາ: {"{"}
                          {"{"}price{"}"}
                          {"}"}
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ຈຳນວນ: {"{"}
                          {"{"}amountCf{"}"}
                          {"}"}
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ລວມເປັນເງິນ: {"{"}
                          {"{"}totalPrice{"}"}
                          {"}"}
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ວັນທີ່: {"{"}
                          {"{"}datetime{"}"}
                          {"}"}
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          -----------------------
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ລູກຄ້າໄດ້ຄອມເມັ້ນ Cf ລະຫັດ ["{"{"}
                          {"{"}cfMessage{"}"}
                          {"}"}"]
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          &nbsp; &nbsp;&nbsp;
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          📌 ຄ່າຝາກຈ່າຍປາຍທາງ&nbsp;
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          &nbsp; &nbsp;&nbsp;
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ໂອນແລ້ວແຈ້ງ
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ຊື່:
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ເບີໂທ:
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ແຂວງ:
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ຝາກ:
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          🔴 ໂອນແລ້ວແຈ້ງໄດ້ເລີຍເດີ້
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <br />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ height: 32 }} />

          </div>
        ) : (
          <div >
            <div style={{ margin: '50px' }} />
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => history.replace('/settings')}>ຕັ້ງຄ່າ</Breadcrumb.Item>
              <Breadcrumb.Item active>ຂໍ້ຄວາມຕອບກັບເຟສບຸກ</Breadcrumb.Item>
            </Breadcrumb>
            <div style={{ margin: '0px 20px' }}>
              <div style={{ display: "flex", justifyContent: "space-around" }}>
                {types.map((type) => (
                  <Tab
                    key={type}
                    active={active === type}
                    onClick={() => {
                      setActive(type);
                      setTabChoice(type);
                    }}
                  >
                    {type}
                  </Tab>
                ))}
              </div>

              {tabChoise == "ອໍເດີ້ເຂົ້າ" ? (
                <div>
                  <div style={{ paddingBottom: 0, marginTop: 10 }}>
                    <div>
                      <p style={{ color: "#1b1b1b", fontWeight: "bold" }}>
                        {" "}
                        <FontAwesomeIcon icon={faComments} />{" "}
                        ຂໍ້ຄວາມຕອບກັບເຟສບຸກໃນໄລຟ ເມື່ອລູກຄ້າ CF ຖືກ
                      </p>
                      <div style={{ width: "100%" }}>
                        <Row style={{ width: "100%" }}>
                          <LiveMessageForSmartPhone
                            rows={12}
                            placeholder="ລາຍລະອຽດຂໍ້ຄວາມທີ່ຈະຕອບກັບໃນເຟສບຸກ..."
                            contents={facebookMessage}
                            ref={textLiveMessageBox}
                            // onChange={(e) => setFacebookMessage(e?.target?.value)}
                            onChange={async (e) => {
                              // console.log("e?.target?.value.length: ", e?.target?.value.length)
                              if (e?.target?.value.length >= 600) {
                                setShowLimitTextModal(true);
                                if (e?.target?.value.length >= 700) return;
                                if (isContinueText) setFacebookMessage(e?.target?.value);
                                return;
                              }
                              setFacebookMessage(e?.target?.value);
                            }}
                          />
                        </Row>
                      </div>
                    </div>
                  </div>

                  <div style={{ paddingBottom: 0, marginTop: 10 }}>
                    <div>
                      <p style={{ color: "#1b1b1b", fontWeight: "bold" }}>
                        {" "}
                        <FontAwesomeIcon icon={faComments} />{" "}
                        ຂໍ້ຄວາມຕອບກັບເຟສບຸກໃນໂພສ ເມື່ອລູກຄ້າ CF ຖືກ
                      </p>
                      <div style={{ width: "100%" }}>
                        <Row style={{ width: "100%" }}>
                          <LiveMessageForSmartPhone
                            rows={22}
                            placeholder="ລາຍລະອຽດຂໍ້ຄວາມທີ່ຈະຕອບກັບໃນເຟສບຸກ..."
                            contents={facebookPostMessage}
                            ref={textPostMessageBox}
                            // onChange={(e) =>
                            //   setFacebookPostMessage(e?.target?.value)
                            // }
                            onChange={async (e) => {
                              // console.log("e?.target?.value.length: ", e?.target?.value.length)
                              if (e?.target?.value.length >= 600) {
                                setShowLimitTextModal(true);
                                if (e?.target?.value.length >= 700) return;
                                if (isContinueText) setFacebookPostMessage(e?.target?.value);
                                return;
                              }
                              setFacebookPostMessage(e?.target?.value);
                            }}
                          />
                        </Row>
                      </div>
                    </div>
                  </div>
                  <div style={{ marginTop: 24, paddingBottom: 10 }}>
                    <Button
                      style={{
                        background: COLOR_APP,
                        color: "#ffff",
                        width: "100%",
                      }}
                      disabled={loadingCreateSetting || loadingUpdateSetting}
                      onClick={_saveSetting}
                    >
                      {loadingCreateSetting || loadingUpdateSetting ? 'ກຳລັງບັນທຶກ....' : 'ບັນທຶກ'}
                    </Button>
                  </div>
                </div>
              ) : (
                <div style={{ marginTop: 20 }}>
                  {/* Topic 1 */}
                  <p style={{ margin: 0, fontSize: 14, fontWeight: "bold" }}>
                    ຄໍາແນະນໍາການຕັ້ງຄ່າ (ຕອບກັບຊີເອຟ)
                  </p>
                  <div
                    style={{
                      border: "1px solid #D1D5DB",
                      boxSizing: "border-box",
                      width: "100%",
                      height: 250,
                    }}
                  >
                    {/* <img src="https://diyforms.net/wp-content/uploads/Blank-Bill-of-Sale-Form.jpg" alt="" style={{width: "100%" ,height:"40%"}}/> */}
                    <p style={{ margin: 0, marginTop: 8 }}>
                      <span
                        style={{
                          color: "rgb(0, 0, 0)",
                          fontFamily: '"Times New Roman"',
                          fontSize: "13px",
                          fontStyle: "normal",
                          fontVariantLigatures: "normal",
                          fontVariantCaps: "normal",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          orphans: 2,
                          textAlign: "left",
                          textIndent: "0px",
                          textTransform: "none",
                          whiteSpace: "pre-wrap",
                          widows: 2,
                          wordSpacing: "0px",
                          WebkitTextStrokeWidth: "0px",
                          textDecorationThickness: "initial",
                          textDecorationStyle: "initial",
                          textDecorationColor: "initial",
                          display: "inline !important",
                          float: "none",
                        }}
                      >
                        1.1{" "}
                        <span
                          style={{
                            color: "#1b1b1b",
                            background: "#eee",
                            paddingLeft: 10,
                            paddingRight: 10,
                            paddingTop: 2,
                            paddingBottom: 4,
                            borderRadius: 20,
                            fontWeight: "bold",
                          }}
                        >
                          {"{"}
                          {"{"}cfName{"}"}
                          {"}"}
                        </span>{" "}
                        ໝາຍເຖິງ: ຊື່ຂອງຜູ້ CF ສິນຄ້າ&nbsp;
                      </span>
                    </p>
                    <p style={{ margin: 0, marginTop: 8 }}>
                      <span
                        style={{
                          color: "rgb(0, 0, 0)",
                          fontFamily: '"Times New Roman"',
                          fontSize: "13px",
                          fontStyle: "normal",
                          fontVariantLigatures: "normal",
                          fontVariantCaps: "normal",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          orphans: 2,
                          textAlign: "left",
                          textIndent: "0px",
                          textTransform: "none",
                          whiteSpace: "pre-wrap",
                          widows: 2,
                          wordSpacing: "0px",
                          WebkitTextStrokeWidth: "0px",
                          textDecorationThickness: "initial",
                          textDecorationStyle: "initial",
                          textDecorationColor: "initial",
                          display: "inline !important",
                          float: "none",
                        }}
                      >
                        1.2{" "}
                        <span
                          style={{
                            color: "#1b1b1b",
                            background: "#eee",
                            paddingLeft: 10,
                            paddingRight: 10,
                            paddingTop: 2,
                            paddingBottom: 4,
                            borderRadius: 20,
                            fontWeight: "bold",
                          }}
                        >
                          {"{"}
                          {"{"}productName{"}"}
                          {"}"}
                        </span>{" "}
                        ໝາຍເຖິງ: ຊື່ຂອງ ສິນຄ້າ&nbsp;
                      </span>
                    </p>
                    <p style={{ margin: 0, marginTop: 8 }}>
                      <span
                        style={{
                          color: "rgb(0, 0, 0)",
                          fontFamily: '"Times New Roman"',
                          fontSize: "13px",
                          fontStyle: "normal",
                          fontVariantLigatures: "normal",
                          fontVariantCaps: "normal",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          orphans: 2,
                          textAlign: "left",
                          textIndent: "0px",
                          textTransform: "none",
                          whiteSpace: "pre-wrap",
                          widows: 2,
                          wordSpacing: "0px",
                          WebkitTextStrokeWidth: "0px",
                          textDecorationThickness: "initial",
                          textDecorationStyle: "initial",
                          textDecorationColor: "initial",
                          display: "inline !important",
                          float: "none",
                        }}
                      >
                        1.3{" "}
                        <span
                          style={{
                            color: "#1b1b1b",
                            background: "#eee",
                            paddingLeft: 10,
                            paddingRight: 10,
                            paddingTop: 2,
                            paddingBottom: 4,
                            borderRadius: 20,
                            fontWeight: "bold",
                          }}
                        >
                          {"{"}
                          {"{"}cfMessage{"}"}
                          {"}"}
                        </span>{" "}
                        ໝາຍເຖິງ: ລະຫັດຊີເອຟສິນຄ້າ
                      </span>
                    </p>
                    <p style={{ margin: 0, marginTop: 8 }}>
                      <span
                        style={{
                          color: "rgb(0, 0, 0)",
                          fontFamily: '"Times New Roman"',
                          fontSize: "13px",
                          fontStyle: "normal",
                          fontVariantLigatures: "normal",
                          fontVariantCaps: "normal",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          orphans: 2,
                          textAlign: "left",
                          textIndent: "0px",
                          textTransform: "none",
                          whiteSpace: "pre-wrap",
                          widows: 2,
                          wordSpacing: "0px",
                          WebkitTextStrokeWidth: "0px",
                          textDecorationThickness: "initial",
                          textDecorationStyle: "initial",
                          textDecorationColor: "initial",
                          display: "inline !important",
                          float: "none",
                        }}
                      >
                        1.4{" "}
                        <span
                          style={{
                            color: "#1b1b1b",
                            background: "#eee",
                            paddingLeft: 10,
                            paddingRight: 10,
                            paddingTop: 2,
                            paddingBottom: 4,
                            borderRadius: 20,
                            fontWeight: "bold",
                          }}
                        >
                          {"{"}
                          {"{"}price{"}"}
                          {"}"}
                        </span>{" "}
                        ໝາຍເຖິງ: ລາຄາສິນຄ້າ
                      </span>
                    </p>
                    <p style={{ margin: 0, marginTop: 8 }}>
                      <span
                        style={{
                          color: "rgb(0, 0, 0)",
                          fontFamily: '"Times New Roman"',
                          fontSize: "13px",
                          fontStyle: "normal",
                          fontVariantLigatures: "normal",
                          fontVariantCaps: "normal",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          orphans: 2,
                          textAlign: "left",
                          textIndent: "0px",
                          textTransform: "none",
                          whiteSpace: "pre-wrap",
                          widows: 2,
                          wordSpacing: "0px",
                          WebkitTextStrokeWidth: "0px",
                          textDecorationThickness: "initial",
                          textDecorationStyle: "initial",
                          textDecorationColor: "initial",
                          display: "inline !important",
                          float: "none",
                        }}
                      >
                        1.5{" "}
                        <span
                          style={{
                            color: "#1b1b1b",
                            background: "#eee",
                            paddingLeft: 10,
                            paddingRight: 10,
                            paddingTop: 2,
                            paddingBottom: 4,
                            borderRadius: 20,
                            fontWeight: "bold",
                          }}
                        >
                          {"{"}
                          {"{"}amountCf{"}"}
                          {"}"}
                        </span>{" "}
                        ໝາຍເຖິງ: ຈຳນວນທີ່ CF
                      </span>
                    </p>
                    <p style={{ margin: 0, marginTop: 8 }}>
                      <span
                        style={{
                          color: "rgb(0, 0, 0)",
                          fontFamily: '"Times New Roman"',
                          fontSize: "13px",
                          fontStyle: "normal",
                          fontVariantLigatures: "normal",
                          fontVariantCaps: "normal",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          orphans: 2,
                          textAlign: "left",
                          textIndent: "0px",
                          textTransform: "none",
                          whiteSpace: "pre-wrap",
                          widows: 2,
                          wordSpacing: "0px",
                          WebkitTextStrokeWidth: "0px",
                          textDecorationThickness: "initial",
                          textDecorationStyle: "initial",
                          textDecorationColor: "initial",
                          display: "inline !important",
                          float: "none",
                        }}
                      >
                        1.5{" "}
                        <span
                          style={{
                            color: "#1b1b1b",
                            background: "#eee",
                            paddingLeft: 10,
                            paddingRight: 10,
                            paddingTop: 2,
                            paddingBottom: 4,
                            borderRadius: 20,
                            fontWeight: "bold",
                          }}
                        >
                          {"{"}
                          {"{"}totalPrice{"}"}
                          {"}"}
                        </span>{" "}
                        ໝາຍເຖິງ: ລວມເປັນເງິນ
                      </span>
                    </p>
                    <p style={{ margin: 0, marginTop: 8 }}>
                      <span
                        style={{
                          color: "rgb(0, 0, 0)",
                          fontFamily: '"Times New Roman"',
                          fontSize: "13px",
                          fontStyle: "normal",
                          fontVariantLigatures: "normal",
                          fontVariantCaps: "normal",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          orphans: 2,
                          textAlign: "left",
                          textIndent: "0px",
                          textTransform: "none",
                          whiteSpace: "pre-wrap",
                          widows: 2,
                          wordSpacing: "0px",
                          WebkitTextStrokeWidth: "0px",
                          textDecorationThickness: "initial",
                          textDecorationStyle: "initial",
                          textDecorationColor: "initial",
                          display: "inline !important",
                          float: "none",
                        }}
                      >
                        1.5{" "}
                        <span
                          style={{
                            color: "#1b1b1b",
                            background: "#eee",
                            paddingLeft: 10,
                            paddingRight: 10,
                            paddingTop: 2,
                            paddingBottom: 4,
                            borderRadius: 20,
                            fontWeight: "bold",
                          }}
                        >
                          {"{"}
                          {"{"}datetime{"}"}
                          {"}"}
                        </span>{" "}
                        ໝາຍເຖິງ: ຈຳນວນທີ່ CF
                      </span>
                    </p>
                  </div>
                  <div
                    style={{
                      border: "1px solid #D1D5DB",
                      boxSizing: "border-box",
                      width: "100%",
                      height: 300,
                      marginTop: 10,
                      paddingTop: 10,
                    }}
                  >
                    <p style={{ margin: 0 }}>
                      <span
                        style={{
                          color: "rgb(0, 0, 0)",
                          fontFamily: '"Times New Roman"',
                          fontSize: "13px",
                          fontStyle: "normal",
                          fontVariantLigatures: "normal",
                          fontVariantCaps: "normal",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          orphans: 2,
                          textAlign: "left",
                          textIndent: "0px",
                          textTransform: "none",
                          whiteSpace: "pre-wrap",
                          widows: 2,
                          wordSpacing: "0px",
                          WebkitTextStrokeWidth: "0px",
                          textDecorationThickness: "initial",
                          textDecorationStyle: "initial",
                          textDecorationColor: "initial",
                          display: "inline !important",
                          float: "none",
                        }}
                      >
                        &nbsp;=========ຕົວຢ່າງການຕັ້ງຄ່າ=======
                      </span>
                    </p>
                    <p style={{ margin: 0 }}>
                      <span
                        style={{
                          color: "rgb(0, 0, 0)",
                          fontFamily: '"Times New Roman"',
                          fontSize: "13px",
                          fontStyle: "normal",
                          fontVariantLigatures: "normal",
                          fontVariantCaps: "normal",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          orphans: 2,
                          textAlign: "left",
                          textIndent: "0px",
                          textTransform: "none",
                          whiteSpace: "pre-wrap",
                          widows: 2,
                          wordSpacing: "0px",
                          WebkitTextStrokeWidth: "0px",
                          textDecorationThickness: "initial",
                          textDecorationStyle: "initial",
                          textDecorationColor: "initial",
                          display: "inline !important",
                          float: "none",
                        }}
                      >
                        ສະບາຍດີ {"{"}
                        {"{"}cfName{"}"}
                        {"}"}, ຍິນດີລູກຄ້າທີ່ໄດ້ Cf ຖືກສິນຄ້ານີ້ແລ້ວເດີ
                      </span>
                    </p>
                    <p style={{ margin: 0 }}>
                      <span
                        style={{
                          color: "rgb(0, 0, 0)",
                          fontFamily: '"Times New Roman"',
                          fontSize: "13px",
                          fontStyle: "normal",
                          fontVariantLigatures: "normal",
                          fontVariantCaps: "normal",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          orphans: 2,
                          textAlign: "left",
                          textIndent: "0px",
                          textTransform: "none",
                          whiteSpace: "pre-wrap",
                          widows: 2,
                          wordSpacing: "0px",
                          WebkitTextStrokeWidth: "0px",
                          textDecorationThickness: "initial",
                          textDecorationStyle: "initial",
                          textDecorationColor: "initial",
                          display: "inline !important",
                          float: "none",
                        }}
                      >
                        ລະຫັດ: {"{"}
                        {"{"}cfMessage{"}"}
                        {"}"}
                      </span>
                    </p>
                    <p style={{ margin: 0 }}>
                      <span
                        style={{
                          color: "rgb(0, 0, 0)",
                          fontFamily: '"Times New Roman"',
                          fontSize: "13px",
                          fontStyle: "normal",
                          fontVariantLigatures: "normal",
                          fontVariantCaps: "normal",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          orphans: 2,
                          textAlign: "left",
                          textIndent: "0px",
                          textTransform: "none",
                          whiteSpace: "pre-wrap",
                          widows: 2,
                          wordSpacing: "0px",
                          WebkitTextStrokeWidth: "0px",
                          textDecorationThickness: "initial",
                          textDecorationStyle: "initial",
                          textDecorationColor: "initial",
                          display: "inline !important",
                          float: "none",
                        }}
                      >
                        ຊື່ສິນຄ້າ: {"{"}
                        {"{"}productName{"}"}
                        {"}"}
                      </span>
                    </p>
                    <p style={{ margin: 0 }}>
                      <span
                        style={{
                          color: "rgb(0, 0, 0)",
                          fontFamily: '"Times New Roman"',
                          fontSize: "13px",
                          fontStyle: "normal",
                          fontVariantLigatures: "normal",
                          fontVariantCaps: "normal",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          orphans: 2,
                          textAlign: "left",
                          textIndent: "0px",
                          textTransform: "none",
                          whiteSpace: "pre-wrap",
                          widows: 2,
                          wordSpacing: "0px",
                          WebkitTextStrokeWidth: "0px",
                          textDecorationThickness: "initial",
                          textDecorationStyle: "initial",
                          textDecorationColor: "initial",
                          display: "inline !important",
                          float: "none",
                        }}
                      >
                        ລາຄາ: {"{"}
                        {"{"}price{"}"}
                        {"}"}
                      </span>
                    </p>
                    <p style={{ margin: 0 }}>
                      <span
                        style={{
                          color: "rgb(0, 0, 0)",
                          fontFamily: '"Times New Roman"',
                          fontSize: "13px",
                          fontStyle: "normal",
                          fontVariantLigatures: "normal",
                          fontVariantCaps: "normal",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          orphans: 2,
                          textAlign: "left",
                          textIndent: "0px",
                          textTransform: "none",
                          whiteSpace: "pre-wrap",
                          widows: 2,
                          wordSpacing: "0px",
                          WebkitTextStrokeWidth: "0px",
                          textDecorationThickness: "initial",
                          textDecorationStyle: "initial",
                          textDecorationColor: "initial",
                          display: "inline !important",
                          float: "none",
                        }}
                      >
                        ຈຳນວນ: {"{"}
                        {"{"}amountCf{"}"}
                        {"}"}
                      </span>
                    </p>
                    <p style={{ margin: 0 }}>
                      <span
                        style={{
                          color: "rgb(0, 0, 0)",
                          fontFamily: '"Times New Roman"',
                          fontSize: "13px",
                          fontStyle: "normal",
                          fontVariantLigatures: "normal",
                          fontVariantCaps: "normal",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          orphans: 2,
                          textAlign: "left",
                          textIndent: "0px",
                          textTransform: "none",
                          whiteSpace: "pre-wrap",
                          widows: 2,
                          wordSpacing: "0px",
                          WebkitTextStrokeWidth: "0px",
                          textDecorationThickness: "initial",
                          textDecorationStyle: "initial",
                          textDecorationColor: "initial",
                          display: "inline !important",
                          float: "none",
                        }}
                      >
                        ລວມເປັນເງິນ: {"{"}
                        {"{"}totalPrice{"}"}
                        {"}"}
                      </span>
                    </p>
                    <p style={{ margin: 0 }}>
                      <span
                        style={{
                          color: "rgb(0, 0, 0)",
                          fontFamily: '"Times New Roman"',
                          fontSize: "13px",
                          fontStyle: "normal",
                          fontVariantLigatures: "normal",
                          fontVariantCaps: "normal",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          orphans: 2,
                          textAlign: "left",
                          textIndent: "0px",
                          textTransform: "none",
                          whiteSpace: "pre-wrap",
                          widows: 2,
                          wordSpacing: "0px",
                          WebkitTextStrokeWidth: "0px",
                          textDecorationThickness: "initial",
                          textDecorationStyle: "initial",
                          textDecorationColor: "initial",
                          display: "inline !important",
                          float: "none",
                        }}
                      >
                        ວັນທີ່: {"{"}
                        {"{"}datetime{"}"}
                        {"}"}
                      </span>
                    </p>
                    <p style={{ margin: 0 }}>
                      <span
                        style={{
                          color: "rgb(0, 0, 0)",
                          fontFamily: '"Times New Roman"',
                          fontSize: "13px",
                          fontStyle: "normal",
                          fontVariantLigatures: "normal",
                          fontVariantCaps: "normal",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          orphans: 2,
                          textAlign: "left",
                          textIndent: "0px",
                          textTransform: "none",
                          whiteSpace: "pre-wrap",
                          widows: 2,
                          wordSpacing: "0px",
                          WebkitTextStrokeWidth: "0px",
                          textDecorationThickness: "initial",
                          textDecorationStyle: "initial",
                          textDecorationColor: "initial",
                          display: "inline !important",
                          float: "none",
                        }}
                      >
                        -----------------------
                      </span>
                    </p>
                    <p style={{ margin: 0 }}>
                      <span
                        style={{
                          color: "rgb(0, 0, 0)",
                          fontFamily: '"Times New Roman"',
                          fontSize: "13px",
                          fontStyle: "normal",
                          fontVariantLigatures: "normal",
                          fontVariantCaps: "normal",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          orphans: 2,
                          textAlign: "left",
                          textIndent: "0px",
                          textTransform: "none",
                          whiteSpace: "pre-wrap",
                          widows: 2,
                          wordSpacing: "0px",
                          WebkitTextStrokeWidth: "0px",
                          textDecorationThickness: "initial",
                          textDecorationStyle: "initial",
                          textDecorationColor: "initial",
                          display: "inline !important",
                          float: "none",
                        }}
                      >
                        ລູກຄ້າໄດ້ຄອມເມັ້ນ Cf ລະຫັດ ["{"{"}
                        {"{"}cfMessage{"}"}
                        {"}"}"]
                      </span>
                    </p>
                    <p style={{ margin: 0 }}>
                      <span
                        style={{
                          color: "rgb(0, 0, 0)",
                          fontFamily: '"Times New Roman"',
                          fontSize: "13px",
                          fontStyle: "normal",
                          fontVariantLigatures: "normal",
                          fontVariantCaps: "normal",
                          fontWeight: 400,
                          letterSpacing: "normal",
                          orphans: 2,
                          textAlign: "left",
                          textIndent: "0px",
                          textTransform: "none",
                          whiteSpace: "pre-wrap",
                          widows: 2,
                          wordSpacing: "0px",
                          WebkitTextStrokeWidth: "0px",
                          textDecorationThickness: "initial",
                          textDecorationStyle: "initial",
                          textDecorationColor: "initial",
                          display: "inline !important",
                          float: "none",
                        }}
                      >
                        ຖ້າຈົບໄລຟ ແລ້ວລະບົບຈະແຈ້ງຍອດໃຫ້ລູກຄ້າເດີ້
                      </span>
                    </p>
                    <p style={{ margin: 0 }}>
                      <br />
                    </p>
                  </div>

                  {/* Topic 2 */}
                  <div style={{ marginTop: 10 }}>
                    <p style={{ margin: 0, fontSize: 14, fontWeight: "bold" }}>
                      ຄໍາແນະນໍາການຕັ້ງຄ່າ (ຕອບກັບຫຼັງໄລຟຈົບ)
                    </p>
                    <div
                      style={{
                        border: "1px solid #D1D5DB",
                        boxSizing: "border-box",
                        width: "100%",
                        height: 300,
                        marginTop: 10,
                        paddingTop: 10,
                      }}
                    >
                      {/* <img  src="https://diyforms.net/wp-content/uploads/Blank-Bill-of-Sale-Form.jpg" alt="" style={{width: "100%" ,height:"40%"}}/> */}
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.1{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}cfText{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ລາຍລະອຽດຂອງສິນຄ້າທີ່ຖືກຊີເອຟ&nbsp;
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.2{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}total{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ຈໍານວນເງິນລວມ&nbsp;
                        </span>
                      </p>
                    
                    </div>
                    <div
                      style={{
                        border: "1px solid #D1D5DB",
                        boxSizing: "border-box",
                        width: "100%",
                        height: 400,
                        marginTop: 10,
                        paddingTop: 10,
                      }}
                    >
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          =========ຕົວຢ່າງການຕັ້ງຄ່າ=======
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ສະບາຍດີລູກຄ້າ {"{"}
                          {"{"}cfName{"}"}
                          {"}"}
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ລາຍການທີ່ລູກຄ້າCFໄດ້ຍອດ
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          {"{"}
                          {"{"}cfText{"}"}
                          {"}"}
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ລວມຍອດທັງໝົດ : {"{"}
                          {"{"}total{"}"}
                          {"}"}
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          &nbsp; &nbsp;&nbsp;
                        </span>
                      </p>

                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          📌 ຄ່າຝາກຈ່າຍປາຍທາງ&nbsp;
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          &nbsp; &nbsp;&nbsp;
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ໂອນແລ້ວແຈ້ງ
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ຊື່:
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ເບີໂທ:
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ແຂວງ:
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ຝາກ:
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          🔴 ໂອນແລ້ວແຈ້ງໄດ້ເລີຍເດີ້
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          <span
                            style={{
                              color: "rgb(0, 0, 0)",
                              fontFamily: '"Times New Roman"',
                              fontSize: "13px",
                              fontStyle: "normal",
                              fontVariantLigatures: "normal",
                              fontVariantCaps: "normal",
                              fontWeight: 400,
                              letterSpacing: "normal",
                              orphans: 2,
                              textAlign: "left",
                              textIndent: "0px",
                              textTransform: "none",
                              whiteSpace: "pre-wrap",
                              widows: 2,
                              wordSpacing: "0px",
                              WebkitTextStrokeWidth: "0px",
                              textDecorationThickness: "initial",
                              textDecorationStyle: "initial",
                              textDecorationColor: "initial",
                              display: "inline !important",
                              float: "none",
                            }}
                          >
                            &nbsp;==================================&nbsp;
                          </span>
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <br />
                      </p>
                    </div>
                  </div>

                  {/* Topic 3 */}
                  <div style={{ marginTop: 10 }}>
                    <p style={{ margin: 0, fontSize: 14, fontWeight: "bold" }}>
                      ຄໍາແນະນໍາການຕັ້ງຄ່າ (ຕອບກັບຊີເອຟ)
                    </p>
                    <div
                      style={{
                        border: "1px solid #D1D5DB",
                        boxSizing: "border-box",
                        width: "100%",
                        height: 400,
                        marginTop: 10,
                        paddingTop: 10,
                      }}
                    >
                      {/* <img  src="https://diyforms.net/wp-content/uploads/Blank-Bill-of-Sale-Form.jpg" alt="" style={{width: "100%" ,height:"40%"}}/> */}
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.1{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}cfName{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ຊື່ຂອງຜູ້ CF ສິນຄ້າ&nbsp;
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.2{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}productName{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ຊື່ຂອງ ສິນຄ້າ&nbsp;
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.3{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}cfMessage{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ລະຫັດຊີເອຟສິນຄ້າ
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.4{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}price{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ລາຄາສິນຄ້າ
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.5{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}amountCf{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ຈຳນວນທີ່ CF
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.5{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}totalPrice{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ລວມເປັນເງິນ
                        </span>
                      </p>
                      <p style={{ margin: 0, marginTop: 8 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          1.5{" "}
                          <span
                            style={{
                              color: "#1b1b1b",
                              background: "#eee",
                              paddingLeft: 10,
                              paddingRight: 10,
                              paddingTop: 2,
                              paddingBottom: 4,
                              borderRadius: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {"{"}
                            {"{"}datetime{"}"}
                            {"}"}
                          </span>{" "}
                          ໝາຍເຖິງ: ວັນທີ CF
                        </span>
                      </p>
                      
                    </div>
                    <div
                      style={{
                        border: "1px solid #D1D5DB",
                        boxSizing: "border-box",
                        width: "100%",
                        height: 500,
                        marginTop: 10,
                        paddingTop: 10,
                      }}
                    >
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          &nbsp;=========ຕົວຢ່າງການຕັ້ງຄ່າ=======
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ສະບາຍດີ {"{"}
                          {"{"}cfName{"}"}
                          {"}"}, ຍິນດີລູກຄ້າທີ່ໄດ້ Cf ຖືກສິນຄ້ານີ້ແລ້ວເດີ
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ລະຫັດ: {"{"}
                          {"{"}cfMessage{"}"}
                          {"}"}
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ຊື່ສິນຄ້າ: {"{"}
                          {"{"}productName{"}"}
                          {"}"}
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ລາຄາ: {"{"}
                          {"{"}price{"}"}
                          {"}"}
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ຈຳນວນ: {"{"}
                          {"{"}amountCf{"}"}
                          {"}"}
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ລວມເປັນເງິນ: {"{"}
                          {"{"}totalPrice{"}"}
                          {"}"}
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ວັນທີ່: {"{"}
                          {"{"}datetime{"}"}
                          {"}"}
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          -----------------------
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ລູກຄ້າໄດ້ຄອມເມັ້ນ Cf ລະຫັດ ["{"{"}
                          {"{"}cfMessage{"}"}
                          {"}"}"]
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          &nbsp; &nbsp;&nbsp;
                        </span>
                      </p>
                      
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          📌 ຄ່າຝາກຈ່າຍປາຍທາງ&nbsp;
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          &nbsp; &nbsp;&nbsp;
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ໂອນແລ້ວແຈ້ງ
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ຊື່:
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ເບີໂທ:
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ແຂວງ:
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          ຝາກ:
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <span
                          style={{
                            color: "rgb(0, 0, 0)",
                            fontFamily: '"Times New Roman"',
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontWeight: 400,
                            letterSpacing: "normal",
                            orphans: 2,
                            textAlign: "left",
                            textIndent: "0px",
                            textTransform: "none",
                            whiteSpace: "pre-wrap",
                            widows: 2,
                            wordSpacing: "0px",
                            WebkitTextStrokeWidth: "0px",
                            textDecorationThickness: "initial",
                            textDecorationStyle: "initial",
                            textDecorationColor: "initial",
                            display: "inline !important",
                            float: "none",
                          }}
                        >
                          🔴 ໂອນແລ້ວແຈ້ງໄດ້ເລີຍເດີ້
                        </span>
                      </p>
                      <p style={{ margin: 0 }}>
                        <br />
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {/* //TODO: Setting Message Reply Invoice Type: web_url, text, postback  */}
        <div style={{ padding: 20, border: "1px solid #ced4da", borderRadius: 5, background: "#fff", margin: 10 }}>
            <h5 style={{ color: "#1b1b1b", fontWeight: "bold" }}> <FontAwesomeIcon icon={faUserCog} /> ປະເພດຂໍ້ຄວາມຕອບອັດຕະໂນມັດ</h5>
            <div className="row">
                <div className="col-12">
                    <Form.Group controlId="messageType">
                        <Form.Label>ເລືອກປະເພດຂໍ້ຄວາມຕອບອັດຕະໂນມັດ</Form.Label>
                        <div style={{ 
                            display: 'flex', 
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                            gap: '15px', 
                            marginTop: '10px', 
                            marginBottom: '20px',
                            '@media (maxWidth: 768px)': {
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                gap: '10px'
                            }
                        }}>
                            <style>
                                {`
                                    @media (max-width: 768px) {
                                        .message-type-option {
                                            min-width: calc(33.333% - 10px) !important;
                                            margin-bottom: 10px;
                                        }
                                    }
                                    @media (max-width: 480px) {
                                        .message-type-option {
                                            min-width: calc(50% - 8px) !important;
                                        }
                                    }
                                `}
                            </style>
                            {[
                                { value: 'web_url', label: 'Web URL', image: '/msg_type_webUrl.png' },
                                { value: 'text', label: 'ຂໍ້ຄວາມ', image: '/msg_type_text.png' },
                                { value: 'postback', label: 'Postback', image: '/msg_type_postback.png' }
                            ].map((option) => (
                                <div 
                                    key={option.value}
                                    className="message-type-option"
                                    onClick={() => setMessageType(option.value)}
                                    style={{
                                        border: `2px solid ${messageType === option.value ? '#422f90' : '#e0e0e0'}`,
                                        borderRadius: '8px',
                                        padding: '10px',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        backgroundColor: messageType === option.value ? '#f5f3ff' : 'white',
                                        flex: '1 1 0',
                                        minWidth: '120px',
                                        transition: 'all 0.2s ease',
                                        boxSizing: 'border-box'
                                    }}
                                >
                                    <img 
                                        src={option.image} 
                                        alt={option.label} 
                                        style={{ 
                                            width: '100%', 
                                            maxWidth: '100px',
                                            height: 'auto',
                                            marginBottom: '8px'
                                        }} 
                                    />
                                    <div style={{ fontWeight: messageType === option.value ? 'bold' : 'normal' }}>
                                        {option.label}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div style={{ marginTop: '20px' }}>
                            <Button 
                                style={{ 
                                    background: COLOR_APP, 
                                    color: '#fff', 
                                    width: '100%',
                                    padding: '10px',
                                    fontSize: '16px',
                                    fontWeight: 'bold'
                                }} 
                                disabled={loadingCreateSetting || loadingUpdateSetting}
                                onClick={() => _saveSetting('message')}
                            >
                                {loadingCreateSetting || loadingUpdateSetting ? 'ກຳລັງບັນທຶກ....' : 'ບັນທຶກການຕັ້ງຄ່າປະເພດຂໍ້ຄວາມ'}
                            </Button>
                        </div>
                    </Form.Group>
                </div>
            </div>
        </div>
        <SettingsCard>
            <SettingsHeader>
                <FontAwesomeIcon icon={faComments} aria-hidden="true" /> 📤 ຂໍ້ຄວາມທວງຍອດ
            </SettingsHeader>
            <div className="row">
              <Form.Label>ກຳນົດຮູບແແບບຂໍຄວາມທວງຍອດທີ່ຕ້ອງການ</Form.Label>
                <div className="col-12 col-lg-4">
                    <Form.Group controlId="msgClaimBalance">
                        <LiveMessage
                          rows={10}
                          placeholder="ລາຍລະອຽດຂໍ້ຄວາມ..."
                          contents={fbClaimBalanceMsg}
                          ref={textPostMessageBox}
                          onChange={handleClaimBalanceMessageChange}
                          aria-label="ຂໍ້ຄວາມທວງຍອດ"
                          aria-describedby="claim-balance-help"
                        />
                        <Form.Text id="claim-balance-help" className="text-muted">
                          ຈຳນວນຕົວອັກສອນສູງສຸດ: {MSG_CLAIM_BALANCE_CHARACTER_LIMIT} ຕົວອັກສອນ
                        </Form.Text>
                    </Form.Group>
                </div>
                {/* Guidance and Example Section for Claim Balance Message */}
                <div className="col-12 col-lg-8">
                  <ClaimBalanceGuidance />
                </div>
                <div className="col-12">
                  <ButtonContainer>
                      <SaveButton 
                          disabled={loadingCreateSetting || loadingUpdateSetting}
                          onClick={() => _saveSetting('message')}
                          aria-label="ບັນທຶກການຕັ້ງຄ່າຂໍ້ຄວາມທວງຍອດ"
                      >
                          {loadingCreateSetting || loadingUpdateSetting ? 'ກຳລັງບັນທຶກ....' : 'ບັນທຶກການຕັ້ງຄ່າປະເພດຂໍ້ຄວາມ'}
                      </SaveButton>
                  </ButtonContainer>
                </div>
            </div>
        </SettingsCard>
      </div>
    </div>
  );
}

// Guidance component for claim balance message variables
const ClaimBalanceGuidance = () => {
  return (
    <div className="row" style={{ margin: 0 }}>
      <div className="col-12 col-md-6">
        <GuideSection>
          <GuideHeader>ຄໍາແນະນໍາການຕັ້ງຄ່າ (ຂໍ້ຄວາມທວງຍອດ)</GuideHeader>
          <GuideItem>
            1.1 <VariableTag>{"{{cfName}}"}</VariableTag> ໝາຍເຖິງ: ຊື່ຂອງຜູ້ CF ສິນຄ້າ
          </GuideItem>
          <GuideItem>
            1.2 <VariableTag>{"{{datetime}}"}</VariableTag> ໝາຍເຖິງ: ວັນທີ CF
          </GuideItem>
          <GuideItem>
            1.3 <VariableTag>{"{{code}}"}</VariableTag> ໝາຍເຖິງ: ເລກລະຫັດອໍເດີ
          </GuideItem>
        </GuideSection>
      </div>
      <div className="col-12 col-md-6">
        <ExampleSection>
          <GuideHeader>=========ຕົວຢ່າງການຕັ້ງຄ່າ=======</GuideHeader>
          <GuideItem>
            🙏ສະບາຍດີ {"{{cfName}}"}
          </GuideItem>
          <GuideItem>
            ⏰ວັນທີ່: {"{{datetime}}"}
          </GuideItem>
          <GuideItem>
            ລູກຄ້າ CF ສິນຄ້າສຳເລັດແລ້ວ ກະລຸນາຊຳລະເງິນໃຫ້ທາງຮ້ານແນ່ເດີ້ເຈົ້າ🥰
          </GuideItem>
          <GuideItem>&nbsp;</GuideItem>
          <GuideItem>👇ຊຳລະເງິນໄດ້ທີ່👇</GuideItem>
        </ExampleSection>
      </div>
    </div>
  );
};

const LiveMessage = React.forwardRef(
  ({ contents, onChange, rows, placeholder }, ref) => {
    const { height, width } = useWindowDimensions();

    return (
      <Form.Group controlId="exampleForm.ControlInput1">
        <Form.Control
          size="default"
          ref={ref}
          as="textarea"
          rows={rows}
          placeholder={placeholder}
          value={contents}
          onChange={onChange}
          style={{
            // width: width * 0.37,
            borderColor: "#ced4da",
            borderRadius: 5,
          }}
        />
      </Form.Group>
    );
  }
);

// Function Live Messages for SmartPhone
const LiveMessageForSmartPhone = React.forwardRef(
  ({ contents, onChange, rows, placeholder }, ref) => {
    return (
      <Form.Group style={{ width: "100%" }}>
        <Form.Control
          ref={ref}
          as="textarea"
          rows={rows}
          placeholder={placeholder}
          value={contents}
          onChange={onChange}
          style={{
            width: "100%",
            borderColor: "#ced4da",
            borderRadius: 5,
            marginLeft: 5,
          }}
        />
      </Form.Group>
    );
  }
);

export default SettingsFacebook;
